<p-card>
    <div class="grid">
        <div class="col-6 md:col-6 lg:col-6 breadcrumbrightmenu">
            <button pButton style="padding: 0.35rem !important;" type="button" icon="fa fa-plus"
                class="dataplus p-button-sm p-button-raised mr-4" pTooltip="Add Help" tooltipPosition="bottom"
                (click)="show('Add Help','')"></button>            
            <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
                (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 1)">
            </button>
        </div>
    </div>

    <div class="mr-0" *ngIf="listarray.length>0">

        <p-table #dt [value]="listarray" [rows]="numberofrowsintable" [scrollable]="true" scrollDirection="horizontal"
            scrollHeight="{{commonScrollHeight}}"
            [globalFilterFields]="['productinitial','productid','rid','topic','sequence','adminflag','activeflag','createdon','firstname']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" sortField="createdon"
            [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
            [resizableColumns]="true" columnResizeMode="expand" paginatorLocale="fa-IR" [paginator]="listarray.length>0"
            [sortOrder]="1" (sortFunction)="customSort($event)" [customSort]="true" responsiveLayout="scroll"
            (onPage)="handlePageChange($event)">

            <!-- search -->
            <ng-template pTemplate="caption">
                <div class="table-header1 ">
                    <div class="grid">
                        <div class="col-8">
                            <span class=" p-input-icon-lft"><i icon="pi pi-search"></i>
                                <input class="form-control" pInputText type="text" id="tablesearch"
                                    (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;"
                                    placeholder="Search in User Help" class="tablesearch"
                                    pTooltip="Enter Search Criteria" tooltipPosition="top" />
                            </span>
                        </div>
                        <div class="col-12 sm:col-2 md:col-2 sm:col-12 ">
                            <div class="iconexcel" pTooltip="Download Excel Data" tooltipPosition="bottom"
                                style="cursor: pointer;" (click)="exceDownloadModel();"></div>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 10px !important;">Action</th>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <th [pSortableColumn]="col.field" *ngIf="col.isChecked " pResizableColumn>
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>

                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-data>
                <tr>
                    <td style="width: 10px !important;">
                        <div style="display: flex; gap: 0px;">
                            <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                                    (click)="show('Modify',data)"></i></span>
                        </div>
                    </td>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <td *ngIf="col.isChecked" (click)="viewData(data)" [style.width]="col.width"
                            [class]="col.class">
                            <span pTooltip=" {{data[col.field] }}"
                                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="listarray.length + 4" class="datanotfound">
                        No data available
                    </td>
                </tr>
            </ng-template>

        </p-table>
    </div>
</p-card>